module.exports = __webpack_public_path__ + "files/99980b5a9c331d42090538eaaa8c04d2.png";